import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";
import { localeRoute } from "./locale";

const searchParamsSchema = z.object({
  rating_token: z.string(),
  user_name: z.string().optional(),
  provider_name: z.string().optional(),
  reservation_id: z.string(),
  score: z
    .number()
    .int()
    .min(1)
    .max(5)
    .optional()
    .or(
      z
        .string()
        .regex(/^[1-5]$/)
        .transform(Number)
        .optional(),
    ),
});

export type CustomerFeedbackParams = z.infer<typeof searchParamsSchema>;

export const customerFeedbackRoute = createRoute({
  path: "/customer-feedback",
  getParentRoute: () => localeRoute,
  validateSearch: (search: Record<string, unknown>): CustomerFeedbackParams => {
    const result = searchParamsSchema.safeParse(search);

    if (!result.success) {
      throw new Error("Invalid customer feedback parameters");
    }

    return result.data;
  },
  component: lazyRouteComponent(() => import("../pages/customer-feedback")),
});

const customerFeedbackSuccessSearchParamsSchema = z.object({
  rating: z.coerce.number().int().min(1).max(5),
  provider_name: z.string().optional(),
  reservation_id: z.string(),
});

export type CustomerFeedbackSuccessParams = z.infer<
  typeof customerFeedbackSuccessSearchParamsSchema
>;

export const customerFeedbackSuccessRoute = createRoute({
  path: "/customer-feedback/success",
  getParentRoute: () => localeRoute,
  validateSearch: (
    search: Record<string, unknown>,
  ): CustomerFeedbackSuccessParams => {
    const result = customerFeedbackSuccessSearchParamsSchema.safeParse(search);

    if (!result.success) {
      throw new Error("Invalid customer feedback success parameters");
    }

    return result.data;
  },
  component: lazyRouteComponent(
    () => import("../pages/customer-feedback-success"),
  ),
});
